module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264.6 162.8"><path class="st0" fill="#fff" d="M0 0h264.6v162.8H0z"/><path class="st15" fill="#342e88" d="M0 0h88.2v162.8H0z"/><path class="st3" fill="#e30613" d="M176.4 0h88.2v162.8h-88.2z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/flag/flg8.svg
// module id = 526
// module chunks = 1